// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___2ekxA","icon":"icon___Wg4_d","text":"text___1O9dB"};